import React from 'react';

import { observer } from 'mobx-react';
import { Button } from '@infoods/lifebase-ui';
import { enqueueSnackbar } from 'notistack';

import classes from './AddScanButton.module.scss';
import { scanIqCustomerProfileStore } from '../../../../../stores/scanIqCustomerProfileStore';
import { getFormattedDate } from '../../../../../../shared/utils/dateUtils';
import { localDateTimeFormat } from '../../../../../../shared/constants/apiDateFormat';
import { scanIqScanService, inbodyIndicatorsStore } from '../../../../../../inbody';
import { setRouteParams } from '../../../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../../../../shared/constants/pathQueryParams';
import { SCAN_IQ_PROFILE_TABS } from '../../../../../constants/scanIqCustomerProfileTabs';

const AddScanButton = observer(() => {
  const { customerProfileInfo, entityId } = scanIqCustomerProfileStore;

  if (!customerProfileInfo || !entityId) {
    return null;
  }

  const handleAddNewScan = async () => {
    const resp = await scanIqScanService.updateScansFromInbody(
      customerProfileInfo.id,
      entityId,
    );

    if (resp.status === 'Success') {
      processAddNewScanSuccess();
    } else {
      enqueueSnackbar('There are no new scans', {
        variant: 'warning',
        autoHideDuration: 3000,
      });
    }
  };

  const processAddNewScanSuccess = async () => {
    // update last scan date time
    await scanIqCustomerProfileStore.refreshCustomerProfileInfo();
    // show last inbody indicators data (i case if user in inbody indicators tab)
    inbodyIndicatorsStore.reInitData();

    enqueueSnackbar('New scan has been added successfully', {
      variant: 'success',
      autoHideDuration: 3000,
    });

    setRouteParams({
      [pathQueryParams.currentTab]: SCAN_IQ_PROFILE_TABS.IN_BODY_INDICATORS,
    });
  };

  return (
    <div>
      <Button fullWidth variant="outlined" onClick={handleAddNewScan}>
        Add New Scan
      </Button>
      {customerProfileInfo.bodyMetrics.scanDateTime && (
        <p className={classes.lastScanLabel}>
          Last Scan:&nbsp;
          {getFormattedDate(
            customerProfileInfo.bodyMetrics.scanDateTime,
            localDateTimeFormat,
          )}
        </p>
      )}
    </div>
  );
});

export { AddScanButton };
